/* eslint-disable react-hooks/exhaustive-deps */
//

import React, { useEffect, useRef, useState } from "react";
import { loadModules } from "esri-loader";
import "antd/dist/reset.css"; // Estilo de Ant Design (opcional)
import {
  Card,
  Modal,
  Select,
  Switch,
  Tooltip,
  Space,
  Descriptions,
  Tag,
  Drawer,
  Spin,
  Empty,
  message,
} from "antd";
import PresetRangoFechas from "../../components/modales/eventos/components/PresetRangoFechas";
import PageHeader from "../../components/headers/PageHeader";
import Contadores from "../../components/Grafana/Contadores";
import ModalNuevoEvento from "../../components/modales/eventos/ModalNuevoEvento";
import axios from "axios";
import dayjs from "dayjs";
import TablaAlarmas from "../dashboard/components/TablaAlarmas";
import Camera from "../../components/modales/camaras/components/Camera";
import camaraIcon from "../../assets/mapIcons/camara-de-video.png";
import { useUser } from "../../context/UserContext";
import useAuth from "../../hooks/useAuth";
import useCamarasEstacion from "../../hooks/useCamarasEstacion";
import eventService from "../../services/eventService";

const InicioPage = () => {
  const user = useUser();
  const { session, Estaciones } = useAuth();
  const team = session?.user?.team;
  const {
    loading: loadingCamaras,
    cargarCamaras,
    camarasDeEstacion,
  } = useCamarasEstacion();

  const mapRef = useRef(null);
  const [view, setView] = useState(null);
  const [eventos, setEventos] = useState([]);
  const [layersEnabled, setLayersEnabled] = useState(false);
  // Controla únicamente la sub-capa de cámaras del servicio MetroGIS (ver
  // `esCapaDeCamaras`). Se activa por separado de `layersEnabled` para que
  // líneas y estaciones aparezcan primero y las cámaras sean opcionales.
  const [camarasLayerEnabled, setCamarasLayerEnabled] = useState(false);
  // Las sub-capas del servicio MetroGIS se guardan juntas: el servicio publica
  // varias y no hay motivo para tratarlas por separado a la hora de pedirlas.
  const metroGisLayersRef = useRef([]);
  const clickHandlerRef = useRef(null);
  const metroGisInterceptorRef = useRef(false);
  const pointerMoveHandleRef = useRef(null);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [hoverTooltip, setHoverTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    count: 0,
  });

  // --- Estaciones y cámaras ---------------------------------------------
  // Las estaciones se pintan en su propia GraphicsLayer (nunca en
  // view.graphics, que el efecto de eventos limpia con removeAll()).
  const [estacionesEnabled, setEstacionesEnabled] = useState(false);
  const estacionesGraphicsRef = useRef(null);
  const camarasGraphicsRef = useRef(null);
  const estacionClickRef = useRef(null);
  const [estacionActiva, setEstacionActiva] = useState(null);
  const [camaraSeleccionada, setCamaraSeleccionada] = useState(null);

  const [, setContador] = useState(0);
  const [open, setOpen] = useState(false);

  const [zonaSeleccionada, setZonaSeleccionada] = useState("Todos");
  const [estadoSeleccionado, setEstadoSeleccionado] = useState([
    "Open",
    "InProgress",
  ]);
  const fetchData = async (startDate, endDate) => {
    const token = user?.idToken || "";
    if (!token) return;

    const start =
      startDate || dayjs().subtract(15, "days").format("YYYY-MM-DD");
    const end = endDate || dayjs().add(1, "days").format("YYYY-MM-DD");

    let allEventos = [];
    let startKey = null;

    try {
      do {
        const data = await eventService.consultarEventos(
          start,
          end,
          startKey,
          token,
          team,
        );
        const batch = (
          data?.Items?.filter((item) =>
            item.id?.match(/^(CISE|EMER)-\d{5}-\d{4}$/),
          ) || []
        ).map((item) => ({
          ...item,
          nameLocation: item.location?.name || null,
        }));
        allEventos = allEventos.concat(batch);
        startKey = data?.LastEvaluatedKey || null;
      } while (startKey);

      allEventos.sort((a, b) => (a.id < b.id ? 1 : -1));
      setEventos(allEventos);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Inicializa el mapa base sin capas GIS
  useEffect(() => {
    let mapView;

    const initMap = async () => {
      const [Map, MapView] = await loadModules(
        ["esri/Map", "esri/views/MapView"],
        { css: true },
      );

      mapView = new MapView({
        container: mapRef.current,
        map: new Map({ basemap: "streets-vector" }),
        center: [-75.5636, 6.2518],
        zoom: 12,
      });

      setView(mapView);
    };

    initMap();

    return () => {
      if (mapView) mapView.destroy();
    };
  }, []);

  // Identifica la sub-capa de cámaras por su título (el único dato fiable:
  // los índices de sub-capa no son estables si el servicio se republica).
  const esCapaDeCamaras = (capa) => /c[aá]mara/i.test(capa?.title || "");

  // Agrega o elimina las sub-capas de MetroGIS y ajusta su visibilidad según
  // los dos switches: "layersEnabled" (líneas y estaciones) y
  // "camarasLayerEnabled" (solo cámaras). Las capas se piden una única vez
  // -la primera vez que cualquiera de los dos se activa- y luego cada switch
  // solo cambia `visible`, sin recargar nada.
  useEffect(() => {
    if (!view) return;

    if (!layersEnabled && !camarasLayerEnabled) {
      metroGisLayersRef.current.forEach((capa) => view.map.remove(capa));
      metroGisLayersRef.current = [];
      if (clickHandlerRef.current) {
        clickHandlerRef.current.remove();
        clickHandlerRef.current = null;
      }
      return;
    }

    const aplicarVisibilidad = () => {
      metroGisLayersRef.current.forEach((capa) => {
        capa.visible = esCapaDeCamaras(capa)
          ? camarasLayerEnabled
          : layersEnabled;
      });
    };

    if (metroGisLayersRef.current.length > 0) {
      aplicarVisibilidad();
      return;
    }

    const metroGisServerRoot =
      process.env.REACT_APP_METROGIS_SERVER_ROOT ||
      "https://metrogis.metrodemedellin.gov.co/server2";
    const metroGisUser = process.env.REACT_APP_METROGIS_USER;
    const metroGisPassword = process.env.REACT_APP_METROGIS_PASSWORD;

    // Servicio de capas del CISE. Reemplaza a Lineas_Sistema_Metro, que solo
    // publicaba líneas, estaciones y edificios.
    const serviceBase =
      process.env.REACT_APP_METROGIS_CISE_SERVICE_URL ||
      `${metroGisServerRoot}/rest/services/Gerencia_social_servicio_cliente/CISE_Camaras/MapServer`;

    // Índices de las sub-capas publicadas en el servicio.
    const capaIds = (
      process.env.REACT_APP_METROGIS_CISE_LAYERS || "1,2,3,4,5,6"
    )
      .split(",")
      .map((id) => parseInt(id.trim(), 10))
      .filter((id) => !isNaN(id));

    const requestToken = async (url) => {
      const params = new URLSearchParams({
        username: metroGisUser,
        password: metroGisPassword,
        f: "json",
        client: "referer",
        referer: window.location.origin,
        expiration: "120",
      });
      const response = await axios.post(url, params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      return response.data?.token || null;
    };

    const addLayer = async () => {
      try {
        const [FeatureLayer, esriConfig] = await loadModules([
          "esri/layers/FeatureLayer",
          "esri/config",
        ]);

        if (
          metroGisUser &&
          metroGisPassword &&
          !metroGisInterceptorRef.current
        ) {
          const tokenUrl =
            "https://metrogis.metrodemedellin.gov.co/portal2/sharing/rest/generateToken";
          const token = await requestToken(tokenUrl);
          if (token) {
            // IdentityManager.registerToken is avoided here because in esri-loader 4.x
            // it fails with "Cannot read properties of undefined (reading 'replace')"
            // when expires/userId are not provided. Using a request interceptor is reliable.
            esriConfig.request.interceptors.push({
              urls: metroGisServerRoot,
              before: (params) => {
                params.requestOptions.query = params.requestOptions.query || {};
                params.requestOptions.query.token = token;
              },
            });
            metroGisInterceptorRef.current = true;
          } else {
            console.warn(
              "MetroGIS: no se obtuvo token; la capa puede no cargarse.",
            );
          }
        }

        const capas = capaIds.map(
          (id) =>
            new FeatureLayer({
              url: `${serviceBase}/${id}`,
              // Sin `title` a propósito: cada sub-capa toma el nombre que
              // tenga publicado en el servicio, que es el único dato fiable
              // sobre su contenido.
              opacity: 0.95,
              outFields: ["*"],
            }),
        );

        view.map.addMany(capas);
        metroGisLayersRef.current = capas;

        // Cargar explícitamente para poder avisar cuál sub-capa falló. Sin
        // esto un 499 "Token Required" deja el mapa vacío sin ningún aviso.
        const resultados = await Promise.allSettled(capas.map((c) => c.load()));
        const fallidas = resultados
          .map((r, i) => (r.status === "rejected" ? capaIds[i] : null))
          .filter((id) => id !== null);

        if (fallidas.length) {
          console.error(
            `MetroGIS: no se cargaron las sub-capas ${fallidas.join(", ")} de ${serviceBase}`,
            resultados
              .filter((r) => r.status === "rejected")
              .map((r) => r.reason),
          );
          message.error(
            `No se pudieron cargar ${fallidas.length} de ${capaIds.length} capas del mapa. Revisa el token de MetroGIS.`,
          );
        }

        aplicarVisibilidad();

        // Abre el modal al hacer click sobre cualquier elemento de las capas
        clickHandlerRef.current = view.on("click", async (event) => {
          const response = await view.hitTest(event, {
            include: metroGisLayersRef.current.filter((c) => c.visible),
          });
          if (response.results.length === 0) return;

          const { graphic } = response.results[0];
          const layerTitle = graphic.layer?.title || "";
          // La estación se reconoce por el atributo y no por el nombre de la
          // capa: así el flujo de cámaras sigue sirviendo sin importar en cuál
          // de las sub-capas queden publicadas las estaciones.
          const type =
            graphic.attributes?.alias_estacion || /estaci/i.test(layerTitle)
              ? "station"
              : "feature";

          setSelectedFeature({
            type,
            layerTitle,
            attributes: graphic.attributes,
          });
        });
      } catch (e) {
        console.error("MetroGIS: error al cargar capas", e);
        message.error("No se pudieron cargar las capas del mapa.");
      }
    };

    addLayer();
  }, [view, layersEnabled, camarasLayerEnabled]);

  // Limpia los íconos de cámaras del mapa y cierra la estación activa.
  const limpiarCamaras = () => {
    if (camarasGraphicsRef.current) camarasGraphicsRef.current.removeAll();
    setEstacionActiva(null);
  };

  /**
   * Dibuja las cámaras de una estación. Se invoca al hacer click sobre la
   * estación: el catálogo completo se pide una sola vez (queda cacheado en el
   * hook) y aquí solo se filtra por `alias_estacion`.
   */
  const mostrarCamarasDeEstacion = async (atributos) => {
    const alias = atributos?.alias_estacion;
    if (!alias) return;

    const nombre = atributos?.nombre || alias;
    setEstacionActiva({ alias, nombre, total: null });

    const catalogo = await cargarCamaras();
    const propias = camarasDeEstacion(alias, catalogo);

    setEstacionActiva({ alias, nombre, total: propias.length });

    if (propias.length === 0) {
      message.info(`La estación ${nombre} no tiene cámaras registradas.`);
      if (camarasGraphicsRef.current) camarasGraphicsRef.current.removeAll();
      return;
    }

    const [Graphic] = await loadModules(["esri/Graphic"]);
    const capa = camarasGraphicsRef.current;
    if (!capa) return;

    capa.removeAll();
    propias.forEach((camara) => {
      capa.add(
        new Graphic({
          geometry: {
            type: "point",
            longitude: camara.lon,
            latitude: camara.lat,
          },
          symbol: {
            type: "picture-marker",
            url: camaraIcon,
            width: "26px",
            height: "26px",
          },
          // `esCamara` permite distinguir estos gráficos en el hitTest.
          attributes: { esCamara: true, ...camara },
        }),
      );
    });
  };

  // Pinta las estaciones (servicio público de ArcGIS Online, ya reproyectado a
  // WGS84 en AuthProvider) y habilita el click para ver sus cámaras.
  useEffect(() => {
    if (!view) return;

    const limpiar = () => {
      if (estacionClickRef.current) {
        estacionClickRef.current.remove();
        estacionClickRef.current = null;
      }
      [estacionesGraphicsRef, camarasGraphicsRef].forEach((ref) => {
        if (ref.current) {
          // Al desmontar la página, el efecto que crea el mapa (declarado
          // antes que este) llama mapView.destroy() en su propia limpieza, y
          // React ejecuta las limpiezas de los efectos en el mismo orden en
          // que fueron declarados. destroy() deja view.map en null, así que
          // para cuando esta limpieza corre, view.map ya no existe. Sin esta
          // guarda: "Cannot read properties of null (reading 'remove')" al
          // navegar a otra vista con las cámaras/estaciones activas.
          if (view.map) view.map.remove(ref.current);
          ref.current = null;
        }
      });
    };

    if (!estacionesEnabled) {
      limpiar();
      setEstacionActiva(null);
      setCamaraSeleccionada(null);
      return;
    }

    let cancelado = false;

    const pintar = async () => {
      const [GraphicsLayer, Graphic] = await loadModules([
        "esri/layers/GraphicsLayer",
        "esri/Graphic",
      ]);
      if (cancelado) return;

      const capaEstaciones = new GraphicsLayer({ title: "Estaciones" });
      const capaCamaras = new GraphicsLayer({ title: "Cámaras" });
      // Las cámaras van encima para que el click las alcance primero.
      view.map.addMany([capaEstaciones, capaCamaras]);
      estacionesGraphicsRef.current = capaEstaciones;
      camarasGraphicsRef.current = capaCamaras;

      (Estaciones || []).forEach((estacion) => {
        const anillos = estacion?.geometry?.rings;
        const atributos = estacion?.attributes;
        if (!anillos || !atributos?.alias_estacion) return;

        capaEstaciones.add(
          new Graphic({
            geometry: { type: "polygon", rings: anillos },
            symbol: {
              type: "simple-fill",
              color: [122, 193, 66, 0.35],
              outline: { color: "#7AC142", width: 1.5 },
            },
            attributes: { esEstacion: true, ...atributos },
          }),
        );
      });

      estacionClickRef.current = view.on("click", async (event) => {
        const resultado = await view.hitTest(event, {
          include: [capaCamaras, capaEstaciones],
        });
        const grafico = resultado.results?.[0]?.graphic;
        if (!grafico) return;

        if (grafico.attributes?.esCamara) {
          setCamaraSeleccionada(grafico.attributes);
        } else if (grafico.attributes?.esEstacion) {
          mostrarCamarasDeEstacion(grafico.attributes);
        }
      });
    };

    pintar();

    return () => {
      cancelado = true;
      limpiar();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view, estacionesEnabled, Estaciones]);

  // // 🔹 Agrega eventos como marcadores en el mapa según su estado
  // useEffect(() => {
  //   if (view && eventos.length > 0) {
  //     loadModules(["esri/Graphic"]).then(([Graphic]) => {
  //       view.graphics.removeAll();

  //       eventos
  //         .filter(
  //           (evento) =>
  //             (evento.state === "Open" || evento.state === "InProgress") &&
  //             (zonaSeleccionada === "Todos" ||
  //               evento.location.zone === zonaSeleccionada)
  //         )
  //         .forEach((evento) => {
  //           const { lat, lon } = evento.location.geolocation;

  //           const point = {
  //             type: "point",
  //             longitude: lon,
  //             latitude: lat,
  //           };

  //           let markerColor = "yellow";
  //           if (evento.state === "InProgress") markerColor = "blue";

  //           const symbol = {
  //             type: "simple-marker",
  //             color: markerColor,
  //             size: "14px",
  //             outline: {
  //               color: "white",
  //               width: 1,
  //             },
  //           };

  //           const attributes = {
  //             title: evento.title,
  //             state: evento.state,
  //           };

  //           const popupTemplate = {
  //             title: "{title}",
  //             content: "Estado: {state}",
  //           };

  //           const graphic = new Graphic({
  //             geometry: point,
  //             symbol: symbol,
  //             attributes: attributes,
  //             popupTemplate: popupTemplate,
  //           });

  //           view.graphics.add(graphic);
  //         });
  //     });
  //   }
  // }, [eventos, view, zonaSeleccionada]); // ← 🔥 añade zonaSeleccionada como dependencia

  // const [cameraModalVisible, setCameraModalVisible] = useState(false);
  // const [selectedDeviceId, setSelectedDeviceId] = useState(null);

  useEffect(() => {
    if (!view) return;

    loadModules(["esri/Graphic"]).then(([Graphic]) => {
      view.graphics.removeAll();

      const STATE_COLOR = {
        InProgress: "blue",
        Open: "yellow",
        FalseAlarm: "red",
        Closed: "green",
      };
      const STATE_PRIORITY = ["InProgress", "Open", "FalseAlarm", "Closed"];
      const BASE_SIZE = 14;

      // Group filtered events by exact coordinate
      const locationMap = new Map();
      eventos
        .filter(
          (evento) =>
            estadoSeleccionado.includes(evento.state) &&
            (zonaSeleccionada === "Todos" ||
              evento.location.zone === zonaSeleccionada),
        )
        .forEach((evento) => {
          const { lat, lon } = evento.location.geolocation;
          const key = `${lat},${lon}`;
          if (!locationMap.has(key))
            locationMap.set(key, { lat, lon, events: [] });
          locationMap.get(key).events.push(evento);
        });

      locationMap.forEach(({ lat, lon, events }) => {
        const count = events.length;
        const size = Math.min(count, 5) * BASE_SIZE;

        const dominantState =
          STATE_PRIORITY.find((s) => events.some((e) => e.state === s)) ||
          events[0].state;

        const graphic = new Graphic({
          geometry: { type: "point", longitude: lon, latitude: lat },
          symbol: {
            type: "simple-marker",
            color: STATE_COLOR[dominantState] || "gray",
            size: `${size}px`,
            outline: { color: "white", width: 1 },
          },
          attributes: {
            isCluster: true,
            count,
            locationKey: `${lat},${lon}`,
          },
          popupTemplate: {
            title: `${count} evento${count !== 1 ? "s" : ""} en esta ubicación`,
            content: events
              .map((e) => `<b>${e.title}</b> — ${e.state}`)
              .join("<br/>"),
          },
        });

        view.graphics.add(graphic);
      });

      // Hover tooltip: show count when pointer is over a cluster graphic
      if (pointerMoveHandleRef.current) pointerMoveHandleRef.current.remove();
      pointerMoveHandleRef.current = view.on("pointer-move", async (event) => {
        const hit = await view.hitTest(event);
        const clusterHit = hit.results.find(
          (r) => r.graphic?.attributes?.isCluster,
        );
        if (clusterHit) {
          setHoverTooltip({
            visible: true,
            x: event.x,
            y: event.y,
            count: clusterHit.graphic.attributes.count,
          });
        } else {
          setHoverTooltip((prev) =>
            prev.visible ? { ...prev, visible: false } : prev,
          );
        }
      });
    });
  }, [view, eventos, zonaSeleccionada, estadoSeleccionado]);

  // Función para obtener la zona numérica del selector
  const getZonaNumerica = () => {
    if (zonaSeleccionada === "Todos") return null;
    return parseInt(zonaSeleccionada);
  };

  return (
    <>
      <Card
        extra={
          <>
            <PresetRangoFechas
              style={{ marginRight: "10px" }}
              onChange={(start, end) =>
                fetchData(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"))
              }
            />

            <Select
              style={{ width: 200, marginLeft: "10px", marginRight: "5px" }}
              value={zonaSeleccionada}
              onChange={(value) => setZonaSeleccionada(value)}
            >
              <Select.Option value="Todos">Todas las Zonas</Select.Option>
              <Select.Option value={1}>Zona 1</Select.Option>
              <Select.Option value={2}>Zona 2</Select.Option>
              <Select.Option value={3}>Zona 3</Select.Option>
              <Select.Option value={4}>Zona 4</Select.Option>
              <Select.Option value={5}>Zona 5</Select.Option>
              <Select.Option value={6}>Zona 6</Select.Option>
            </Select>

            <div
              style={{
                display: "inline-block",
                marginLeft: "10px",
                marginRight: "5px",
              }}
            >
              <div
                style={{ fontSize: "12px", color: "#666", marginBottom: "2px" }}
              >
                Estado de Eventos:
              </div>
              <Select
                mode="multiple"
                style={{ width: 250 }}
                placeholder="Seleccionar estados"
                value={estadoSeleccionado}
                onChange={(value) => setEstadoSeleccionado(value)}
                options={[
                  { label: "Abierto", value: "Open" },
                  { label: "Ejecutando", value: "InProgress" },
                  { label: "Falsa Alarma", value: "FalseAlarm" },
                  { label: "Cerrado", value: "Closed" },
                  { label: "Cancelado", value: "Cancelled" },
                ]}
              />
            </div>

            {/* <Button
              style={{ marginRight: "5px" }}
              icon={
                <Badge count={contador} offset={[8, 0]}>
                  <BellOutlined style={{ fontSize: "20px" }} />
                </Badge>
              }
              onClick={() => setOpen(true)}
            >
              Alarmas
            </Button> */}

            <Tooltip title="Mostrar líneas y estaciones del sistema Metro">
              <Space
                size={6}
                style={{ marginLeft: 10, marginRight: 5, cursor: "pointer" }}
                onClick={() => setLayersEnabled((v) => !v)}
              >
                <span style={{ fontSize: 12, color: "#999" }}>
                  Líneas y Estaciones
                </span>
                <Switch size="small" checked={layersEnabled} />
              </Space>
            </Tooltip>

            {/* <Tooltip title="Mostrar la capa de cámaras del sistema Metro sobre el mapa">
              <Space
                size={6}
                style={{ marginLeft: 10, marginRight: 5, cursor: "pointer" }}
                onClick={() => setCamarasLayerEnabled((v) => !v)}
              >
                <span style={{ fontSize: 12, color: "#999" }}>Cámaras (mapa)</span>
                <Switch size="small" checked={camarasLayerEnabled} />
              </Space>
            </Tooltip> */}

            <Tooltip title="Mostrar estaciones; haz click en una para ver sus cámaras">
              <Space
                size={6}
                style={{ marginLeft: 10, marginRight: 5, cursor: "pointer" }}
                onClick={() => setEstacionesEnabled((v) => !v)}
              >
                <span style={{ fontSize: 12, color: "#999" }}>Estaciones</span>
                <Switch size="small" checked={estacionesEnabled} />
              </Space>
            </Tooltip>

            <ModalNuevoEvento
              zonaPreSeleccionada={getZonaNumerica()}
              fetchData={fetchData}
            />

            <Modal
              title={<PageHeader title="Registro de alarmas"></PageHeader>}
              centered
              open={open}
              onCancel={() => setOpen(false)}
              width={"90%"}
              footer={false}
            >
              <TablaAlarmas setContador={setContador} />
            </Modal>
          </>
        }
        title={
          <PageHeader
            title="Inicio"
            head=""
            help={true}
            mensaje="Bienvenido a la plataforma de CISE.

            En la página de inicio encontrarás los contadores que te brindarán información sobre la cantidad de eventos registrados en los últimos 15 días.
            También podrás filtrar por zona, visualizar las alarmas del sistema y crear un nuevo evento de forma sencilla."
          ></PageHeader>
        }
      >
        <Contadores filtroZona={zonaSeleccionada} eventos={eventos} />
        <div style={{ position: "relative", width: "100%", marginTop: "10px" }}>
          <div ref={mapRef} style={{ width: "100%", height: "100vh" }} />
          {hoverTooltip.visible && (
            <div
              style={{
                position: "absolute",
                left: hoverTooltip.x + 14,
                top: hoverTooltip.y - 10,
                background: "rgba(0,0,0,0.72)",
                color: "#fff",
                padding: "4px 10px",
                borderRadius: 4,
                fontSize: 13,
                pointerEvents: "none",
                whiteSpace: "nowrap",
                zIndex: 10,
              }}
            >
              {hoverTooltip.count} evento{hoverTooltip.count !== 1 ? "s" : ""}
            </div>
          )}

          {estacionActiva && (
            <div
              style={{
                position: "absolute",
                top: 12,
                left: 12,
                background: "rgba(255,255,255,0.95)",
                border: "1px solid #e6e6e6",
                borderRadius: 6,
                padding: "8px 12px",
                fontSize: 13,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                zIndex: 10,
              }}
            >
              <Space size={8}>
                <Tag color="#7AC142">{estacionActiva.alias}</Tag>
                <strong>{estacionActiva.nombre}</strong>
                {loadingCamaras || estacionActiva.total === null ? (
                  <Spin size="small" />
                ) : (
                  <span style={{ color: "#666" }}>
                    {estacionActiva.total} cámara
                    {estacionActiva.total !== 1 ? "s" : ""}
                  </span>
                )}
                <button
                  onClick={limpiarCamaras}
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    color: "#999",
                    fontSize: 15,
                    lineHeight: 1,
                  }}
                  title="Quitar cámaras del mapa"
                >
                  ×
                </button>
              </Space>
            </div>
          )}
        </div>
      </Card>

      <Drawer
        open={!!camaraSeleccionada}
        onClose={() => setCamaraSeleccionada(null)}
        width={560}
        destroyOnClose
        title={
          <Space>
            <Tag color="#7AC142">{camaraSeleccionada?.estacion}</Tag>
            {camaraSeleccionada?.nombre || "Cámara"}
          </Space>
        }
      >
        {camaraSeleccionada ? (
          <>
            <Camera
              width="100%"
              height="320px"
              deviceId={camaraSeleccionada.deviceId}
            />
            <Descriptions
              column={1}
              size="small"
              bordered
              style={{ marginTop: 16 }}
              items={[
                {
                  key: "equipo",
                  label: "Equipo",
                  children: camaraSeleccionada.equipo || "—",
                },
                {
                  key: "tec",
                  label: "Tecnología",
                  children: camaraSeleccionada.tecnologia || "—",
                },
                {
                  key: "linea",
                  label: "Línea",
                  children: camaraSeleccionada.linea || "—",
                },
                {
                  key: "dev",
                  label: "Device ID",
                  children: camaraSeleccionada.deviceId,
                },
              ]}
            />
          </>
        ) : (
          <Empty description="Sin cámara seleccionada" />
        )}
      </Drawer>

      <Modal
        open={!!selectedFeature}
        onCancel={() => setSelectedFeature(null)}
        footer={null}
        title={
          <Space>
            <Tag color={selectedFeature?.type === "station" ? "blue" : "green"}>
              {selectedFeature?.type === "station"
                ? "Estación"
                : selectedFeature?.layerTitle || "Elemento"}
            </Tag>
            {selectedFeature?.attributes
              ? selectedFeature.attributes.NOMBRE ||
                selectedFeature.attributes.nombre ||
                selectedFeature.attributes.Name ||
                selectedFeature.attributes.NAME ||
                selectedFeature.attributes.ESTACION ||
                "Sin nombre"
              : ""}
          </Space>
        }
        width={480}
      >
        {selectedFeature && (
          <Descriptions
            column={1}
            size="small"
            bordered
            items={Object.entries(selectedFeature.attributes)
              .filter(
                ([key, val]) =>
                  val !== null &&
                  val !== undefined &&
                  ![
                    "OBJECTID",
                    "objectid",
                    "Shape",
                    "Shape_Length",
                    "Shape_Area",
                    "GlobalID",
                  ].includes(key),
              )
              .map(([key, val]) => ({
                key,
                label: key,
                children: String(val),
              }))}
          />
        )}
      </Modal>
    </>
  );
};

export default InicioPage;
